export enum TaskStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  IN_PROGRESS = 'in_progress',
  DELAYED = 'delayed',
  CANCELLED = 'cancelled',
}

export const TaskStatusWordMap = {
  pending: 'pending',
  completed: 'completed',
  in_progress: 'in progress',
  delayed: 'delayed',
  cancelled: 'cancelled',
};

export enum TaskPriority {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

export interface ITimelineItem {
  establishment: string;
  location: string;
  establishmentType: string;
  numberOfProducts: number;
  reportLink?: string;
  status: TaskStatus;
}

export interface IWeeklyTimelineItem extends ITimelineItem {
  priority: TaskPriority;
  assignees: string[];
  establishmentId: number;
  basketId?: number;
  locationId: number;
  refId: string;
  productId: string[];
  taskName: string;
  taskTypeKey?: string;
  subTaskTypeKey?: string;
  fuelStationName?: string;
}

export interface IWeeklyTimeline {
  [day: number | string]: IWeeklyTimelineItem[];
}
